import React from 'react';
import { useTranslate } from '@/translations';
import { PageContainer, Title, faBriefcase } from '@/ui/components';
import { Card } from 'antd';
import { CompaniesDataGrid } from './components/CompaniesDataGrid/CompaniesDataGrid';

export const AdminCompanies: React.FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('manageCompanies')} icon={faBriefcase} />

      <Card>
        <CompaniesDataGrid />
      </Card>
    </PageContainer>
  );
};
